function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoLinkPreviewTemplate = require('./saito-link-preview.template');

/**
 * Open Graph / URL preview card (chat and other rich-message surfaces).
 */
var SaitoLinkPreview = /*#__PURE__*/function () {
  function SaitoLinkPreview(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var url = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var link_properties = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    _classCallCheck(this, SaitoLinkPreview);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.url = url;
    this.display_url = url;
    this.link_properties = link_properties;
    this.show_photo = false;
    this.src = '';
    this.title = '';
    this.description = '';
    if (this.link_properties) {
      if (this.link_properties['og:image']) {
        this.src = this.link_properties['og:image'];
        this.show_photo = true;
      }
      if (this.link_properties['og:url'] && this.link_properties['og:url'] != 'undefined') {
        this.display_url = this.link_properties['og:url'];
      }
      if (this.link_properties['og:title']) {
        this.title = this.link_properties['og:title'];
      }
      if (this.link_properties['saito:title']) {
        this.title = this.link_properties['saito:title'];
      }
      if (this.link_properties['og:description']) {
        this.description = this.link_properties['og:description'];
      }
      if (this.link_properties['saito:description']) {
        this.description = this.link_properties['saito:description'];
      }
    }
  }
  return _createClass(SaitoLinkPreview, [{
    key: "render",
    value: function render() {
      if (this.url) {
        if (!this.container) {
          console.warn('SaitoLinkPreview: empty container, skipping render');
          return;
        }
        var qs = this.container + ' > .saito-link-preview';
        if (document.querySelector(qs)) {
          this.app.browser.replaceElementBySelector(SaitoLinkPreviewTemplate(this), qs);
        } else if (document.querySelector(this.container)) {
          this.app.browser.addElementToSelector(SaitoLinkPreviewTemplate(this), this.container);
        }
        this.attachEvents();
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      if (this.src) {
        if (!this.test) {
          this.test = new Image();
          this.test.onerror = function () {
            _this.show_photo = false;
            console.warn('Saito image load failed! \n', _this.title, _this.src);
            if (_this.src.toLowerCase().includes('saito')) {
              _this.src = '/saito/img/backgrounds/red_cube_dark.jpg';
              _this.show_photo = true;
            } else if (!_this.app.browser.urlRegexp().test(_this.src) && !_this.src.includes('data:')) {
              var img_type = 'jpeg';
              if (_this.src.charAt(0) == 'i') {
                img_type = 'png';
              }
              if (_this.src.charAt(0) == 'R') {
                img_type = 'gif';
              }
              _this.src = "data:image/".concat(img_type, ";base64,") + _this.src;
              _this.show_photo = true;
            } else {
              _this.src = '/saito/img/dreamscape.png';
            }
            _this.render();
          };
          this.test.src = this.src;
        }
      }
    }
  }]);
}();
module.exports = SaitoLinkPreview;